var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvailableWrits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#C9B2ED",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5333 7.47333C16.26 7.2 15.7866 7.38667 15.7866 7.76667V10.0933C15.7866 11.0667 16.6133 11.8733 17.62 11.8733C18.2533 11.88 19.1333 11.88 19.8866 11.88C20.2666 11.88 20.4666 11.4333 20.2 11.1667C19.24 10.2 17.52 8.46 16.5333 7.47333Z",
    fill: "#C9B2ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 12.7933H17.7401C16.1601 12.7933 14.8734 11.5067 14.8734 9.92667V8C14.8734 7.63334 14.5734 7.33334 14.2067 7.33334H11.3801C9.32675 7.33334 7.66675 8.66667 7.66675 11.0467V16.9533C7.66675 19.3333 9.32675 20.6667 11.3801 20.6667H16.6201C18.6734 20.6667 20.3334 19.3333 20.3334 16.9533V13.46C20.3334 13.0933 20.0334 12.7933 19.6667 12.7933ZM13.6667 17.8333H11.0001C10.7267 17.8333 10.5001 17.6067 10.5001 17.3333C10.5001 17.06 10.7267 16.8333 11.0001 16.8333H13.6667C13.9401 16.8333 14.1667 17.06 14.1667 17.3333C14.1667 17.6067 13.9401 17.8333 13.6667 17.8333ZM15.0001 15.1667H11.0001C10.7267 15.1667 10.5001 14.94 10.5001 14.6667C10.5001 14.3933 10.7267 14.1667 11.0001 14.1667H15.0001C15.2734 14.1667 15.5001 14.3933 15.5001 14.6667C15.5001 14.94 15.2734 15.1667 15.0001 15.1667Z",
    fill: "#C9B2ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableWrits);
export default __webpack_public_path__ + "static/media/AvailableWrits.5003f33358437399faccca5411a6f10c.svg";
export { ForwardRef as ReactComponent };